<div [ngClass]="{ inlineChildElements: !requiresRecordNavigation() }">
  @if (requiresSelectTempElement()) {
    <div class="template-title">
      <span>
        {{ selectedTemplateTitle }}
      </span>
    </div>
  }
  <div class="action-bar">
    <form [formGroup]="navControlsFG">
      <div [ngClass]="{ onlyRecordNavigation: requiresRecordNavigation() && !requiresSelectTempElement() }">
        @if (requiresRecordNavigation()) {
          <div class="navigation-controls">
            <label>{{ 'template.record' | translate }}</label>
            <input type="number" name="recordNumber" formControlName="recordNumber" (blur)="onRecordNumChange()" />
            <span>/ &nbsp; {{ recordsCount() }}</span>
            <button class="left-arrow" (click)="prevRecord()" [disabled]="prevRecordError">
              <mat-icon svgIcon="leftnav"></mat-icon>
            </button>
            <button class="right-arrow" (click)="nextRecord()" [disabled]="nextRecordError">
              <mat-icon svgIcon="rightnav"></mat-icon>
            </button>
          </div>
        }
        @if (navControlsFG?.get('recordNumber')?.errors) {
          <div class="errMsg">
            <div>{{ errorMessage }}</div>
          </div>
        }
      </div>
      @if (navControlsFG?.get('recordNumber')?.errors) {
        <div class="errMsg">
          <div>{{ errorMessage }}</div>
        </div>
      }
      @if (requiresSelectTempElement() && !isUKFeaturesEnabled()) {
        <button
          class="change-template-btn"
          (click)="openTemplates()"
          >
          {{ 'template.changeTemplate' | translate }}
        </button>
      }
    </form>
  </div>
</div>
